import { render, staticRenderFns } from "./singleCountryCard.vue?vue&type=template&id=2e4dbc98&scoped=true&"
import script from "./singleCountryCard.vue?vue&type=script&lang=js&"
export * from "./singleCountryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4dbc98",
  null
  
)

export default component.exports